import { MapActionsSnackbarModule } from '@/store/snackbar/map-actions.snackbar';
import { RecuperacaoInterface } from '@/shared/models/recuperacao/recuperacao.interface';
import { UsuarioInterface } from '@/shared/models/usuario/usuario.interface';
import { UsuarioFilter } from '@/shared/models/usuario/usuario.filter';
import store from '@/store';
import redirectUtil from '@/shared/utils/redirect.util';
import queryUtil from '@/shared/utils/query.util';
import { instanciaAxios } from './base.service';

const usuarioInterno = 'usuario-interno';

export default class UsuarioInternoService {
  async buscarPorFiltro(filtro: UsuarioFilter, mostrarMensagem: boolean): Promise<any> {
    const query = queryUtil.getQuery(filtro);
    return await instanciaAxios.get(`${usuarioInterno}${query}`)
      .then((response: any) => {
        const lista: Array<UsuarioInterface> = response.data;
        if (mostrarMensagem) {
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Pesquisa concluída!');
        }
        return lista;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async buscarPorCPF(cpf: string): Promise<any> {
    return await instanciaAxios.get(`${usuarioInterno}?cpf=${cpf}`)
      .then((response: any) => {
        const lista: Array<UsuarioInterface> = response.data;
        return lista[0];
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async salvarAtualizar(body: UsuarioInterface): Promise<any> {
    if (body.id) {
      await instanciaAxios.put(`${usuarioInterno}/${body.cpf}`, body)
        .then(() => {
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Usuário editado com sucesso!');
        })
        .catch((error: any) => {
          console.error(error.response);
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
          return Promise.reject();
        });
    } else {
      await instanciaAxios.post(usuarioInterno, body)
        .then(() => {
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Usuário cadastrado com sucesso!');
        })
        .catch((error: any) => {
          console.error(error.response);
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
          return Promise.reject();
        });
    }
  }

  async excluir(usuario: UsuarioInterface): Promise<any> {
    await instanciaAxios.delete(`${usuarioInterno}/${usuario.cpf}`)
      .then(() => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Usuário excluído com sucesso!');
      })
      .catch((error) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }

  async alterarSenha(body: RecuperacaoInterface, vue: Vue): Promise<any> {
    await instanciaAxios.put(`${usuarioInterno}/alterar-acesso`, body)
      .then(() => {
        redirectUtil.redirecionar(vue, 'login', null);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Senha alterada com sucesso!');
      })
      .catch((error: any) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
      });
  }
}
